import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { PointingService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { OperationContext } from "../../CreateOperation";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { ColumnItem } from "../../../../../../common/models/table";
import { usePointingCraftStore } from "../../../../store/PointingStore";
import { useOperationType } from "../../../../core/_context";
import { getLoadStateTagData } from "../../../../../../utilities/LoadStateTag";
import { Tag } from "antd";
import { LFTableV3 } from "../../../../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../../../../common/components/Drawer/CustomDrawer";
import { ActionsKey } from "../../../../../../common/models/Actions";
import { CraftDetails } from "../details/craftDetails/CraftDetails";

export const LandingCraftPointingList = () => {
  const { initialValue } = useContext(OperationContext);

  const { list, pageState, totalItems, setList, resetPageState, setPageState, actioned, setActioned } =
    usePointingCraftStore();
  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");
  const type = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);

  const operationType = useOperationType();

  const cols: ColumnItem[] = [
{
      key: "name",
      title: "Nom",
      dataIndex: "name",
      show: true,
      // isCanSort: true,
    },
    {
      key: "className",
      title: "Classe",
      dataIndex: "className",
      show: true,
    },
    {
      key: "volume",
      title: "Volume",
      dataIndex: "volume",
      show: true,
    },

    {
      key: "loadState",
      title: "Etat",
      dataIndex: "loadState",
      show: true,
      // isCanSort: true,
      nestedKey: "loadState.id",
      render: (state: any) => {
        const { label, color } = getLoadStateTagData(state?.id);
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <Tag color={color}>{label}</Tag>
          </div>
        );
      },
    },

    {
      key: "craftType",
      title: "Type",
      dataIndex: "craftType",
      show: true,
      // isCanSort: true,
      nestedKey: "craftType.id",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "tonnage",
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      show: true,
      // isCanSort: true,
    },
    ...(operationType === "sales"
      ? [
          {
            key: "pointingOnBoardPeriod",
            title: "Pointage à Bord",
            dataIndex: "pointingOnBoardPeriod",
            show: true,
            // isCanSort: true,
          } as ColumnItem,
        ]
      : []),
    // {
    //   key: "inspectionDocksidePeriod",
    //   title: "Inspection à Quai",
    //   dataIndex: "inspectionDocksidePeriod",
    //   show: true,
    //   // isCanSort: true,
    // },

    {
      key: "pointingDocksidePeriod",
      title: operationType === "sales" ? "Pointage à Quai" : "Pointage",
      dataIndex: "pointingDocksidePeriod",
      show: true,
      // isCanSort: true,
    },
  ];

  useEffect(() => {
    const selected =
      initialValue?.debarkationMovement?.loadPossessionStatus?.find(
        (item: any) => item.id === type?.toUpperCase()
      ) ?? initialValue?.debarkationMovement?.loadPossessionStatus?.[0];

    if (selected && selected?.url && movement) {
      getMovement(`${selected?.url}/controlled`, {
        ...pageState,
        "movement.id": movement,
        isLoadControlled: true,
      });
    }
  }, [movement, pageState, type]);

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await PointingService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowDrawer = () => {
      setIsShowDrawer((prev: boolean) => !prev);
    };
  
    const onActionClick = (item: any, action: ActionsKey) => {
      if (action === "delete") {
        // onDeleteHandler(item?.id);
      } else {
        handleShowDrawer();
        setActioned({
          data: item,
          action,
        });
      }
    };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <LFTableV3
        columns={cols}
        data={list}
        params={pageState}
        onAction={onActionClick}
        isCanShow={() => true}
        onSearch={setPageState}
        onSort={setPageState}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={setPageState}
      />
      {isShowDrawer && (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={handleShowDrawer}
          title={`${actioned?.action === "read" ? "Détails" : "Modification"}`}
        >
          <CraftDetails initialValue={actioned?.data} />
        </CustomDrawer>
      )}
    </div>
  );
};
